import React from 'react'
import { Link } from 'gatsby'
import blogTagStyles from './blogtag.module.scss'
const BlogTag = ({tags}) => {
    return (
        <ul className={blogTagStyles.tags}>
            {tags.map(tag => {
                return (
                <li className={blogTagStyles.li}>
                    <Link to={`/tags/${tag}`}  className={blogTagStyles.tag}>
                    {tag}<span>  </span>
                    </Link>

                </li>
                )
            })}
        </ul>
    )
}

export default BlogTag